import { StatsByCategoryMap } from "../../types";
import { calcPercentage } from "../../utils/stats.util";
import { SectionHeader } from "../section-header";
import { StatCard } from "../stat-card";
import React from "react";
import { LuCalendar as Calendar } from "react-icons/lu";

type Props = {
  stats: StatsByCategoryMap["BOOKINGS"];
  expiry: number;
};

export const BookingStatsSection: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mb-8">
      <SectionHeader icon={Calendar} title="Bookings Statistics" updateInfo={expiry} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={Calendar} title="Total Bookings" value={stats.TOTAL_BOOKINGS.count} />
        <StatCard
          icon={Calendar}
          title="Bookings (Last Month)"
          value={stats.LAST_MONTH_BOOKINGS.count}
          change={`${calcPercentage(stats.TOTAL_BOOKINGS.count, stats.LAST_MONTH_BOOKINGS.count)}% of Total`}
        />
      </div>
    </div>
  );
};
